export const Refresh = () => {
  return (
    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 14V10H5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 2V6H13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.82545 5.66605C3.1943 4.55104 3.82119 3.55414 4.64761 2.76839C5.47404 1.98264 6.47307 1.43365 7.55148 1.17263C8.6299 0.91161 9.75255 0.947078 10.8147 1.27572C13.2259 2.02179 15.15 4.38382 17 6M1 10C2.85005 11.6162 4.77412 13.9782 7.18532 14.7243C8.24745 15.0529 9.3701 15.0884 10.4485 14.8274C11.5269 14.5664 12.526 14.0174 13.3524 13.2316C14.1788 12.4459 14.8057 11.449 15.1745 10.3339"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
